import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ApiService } from './api';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private api = inject(ApiService);
  
  // BehaviorSubject holds current value and emits to subscribers
  private profileSubject = new BehaviorSubject<User | null>(null);

  // Expose as readonly observable to other parts of app
  profile$ = this.profileSubject.asObservable();

  /**
   * Call this to load the profile from API
   */
  getProfile(): Observable<User> {
    return this.api.get<User>('accounts/profile', true).pipe(
      tap((profile) => this.profileSubject.next(profile))
    );
  }

  /**
   * Call this to set the profile manually (e.g., after login)
   */
  setProfile(profile: User): void {
    this.profileSubject.next(profile);
  }

  /**
   * Clear the profile (e.g., on logout)
   */
  clearProfile(): void {
    this.profileSubject.next(null);
  }

  /**
   * Get the current profile value synchronously
   */
  getProfileValue(): User | null {
    return this.profileSubject.value;
  }

  updateMyProfile(payload: User) {
    return this.api.put('accounts/profile', payload);
  }

  updateMyPassword(payload: any) {
    return this.api.post('accounts/profile/change-password', payload);
  }

  hasPermission(module: string, permissionKey: string): boolean {
    const profile = this.getProfileValue();
    if (!profile || !profile.roles.auth_items) {
      return false;
    }
    
    if (profile.is_admin) {
      return true;
    }

    const permissions = profile.roles.auth_items[module];
    if (!permissions) {
      return false;
    }

    return !!permissions[permissionKey];;
  }
}
